<template>
  <div>
    <el-tabs v-model="activeTabName">
      <el-tab-pane name="账号留存" label="账号留存">
        <AccountRetentionPage v-if="activeTabName == '账号留存'" />
      </el-tab-pane>
      <el-tab-pane name="每日创角" label="每日创角">
        <DailyPlayersPage v-if="activeTabName == '每日创角'" />
      </el-tab-pane>
      <el-tab-pane name="通关率" label="通关率">
        <LevelPassRatePage v-if="activeTabName == '通关率'" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import AccountRetentionPage from "./tab-pages/AccountRetentionPage";
import DailyPlayersPage from "./tab-pages/DailyPlayersPage";
import LevelPassRatePage from "./tab-pages/LevelPassRatePage";

export default {
  data() {
    return {
      activeTabName: "账号留存",
    };
  },

  components: {
    AccountRetentionPage,
    DailyPlayersPage,
    LevelPassRatePage,
  },
};
</script>